module.exports = __webpack_public_path__ + "img/item_link_packaging.047f0a8.jpg";